<div class="fb-outline" *ngIf="visible">
  <div class="fb-outline__header">
    <i class="fa-solid fa-sitemap"></i>
    <span>Form Outline</span>
  </div>
  <div class="fb-outline__tree">
    <ng-container *ngFor="let node of tree; trackBy: trackByNodeKey">
      <ng-container
        *ngTemplateOutlet="nodeTpl; context: { $implicit: node, depth: 0 }">
      </ng-container>
    </ng-container>
    <div class="fb-outline__empty" *ngIf="tree.length === 0">
      No form structure found.
    </div>
  </div>
</div>

<!-- Recursive node renderer: handles section > block > group/repeater > field -->
<ng-template #nodeTpl let-node let-depth="depth">
  <div
    class="fb-outline__node"
    [class.fb-outline__node--section]="node.type === 'section'"
    [class.fb-outline__node--block]="node.type === 'block'"
    [class.fb-outline__node--field]="node.type === 'field'"
    [class.fb-outline__node--selected]="isSelected(node)"
    [style.padding-left.px]="depth * 14 + 8">
    <button
      class="fb-outline__toggle"
      *ngIf="node.children.length; else toggleSpacer"
      (click)="toggleNode(node, $event)">
      <i
        [class]="
          node.expanded
            ? 'fa-solid fa-chevron-down'
            : 'fa-solid fa-chevron-right'
        "></i>
    </button>
    <ng-template #toggleSpacer
      ><span class="fb-outline__toggle-spacer"></span
    ></ng-template>
    <i [class]="node.icon" class="fb-outline__icon"></i>
    <span class="fb-outline__label" (click)="selectNode(node, $event)">{{
      node.label
    }}</span>
  </div>
  <ng-container *ngIf="node.expanded && node.children.length">
    <ng-container *ngFor="let child of node.children; trackBy: trackByNodeKey">
      <ng-container
        *ngTemplateOutlet="
          nodeTpl;
          context: { $implicit: child, depth: depth + 1 }
        ">
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
